import React from 'react'
import TableCellMobile from './TableCellMobile'
import TableCellDesktop from './TableCellDesktop'

const TableCellSemaines = ({
  item,
  label,
  device
}) => {
  const value = item.semaines
  const object = {
    value: value,
    empty: (value === 0)
  }
  return (device.mobile)
    ? <TableCellMobile
        label={label}
        {...object}
      />
    : <TableCellDesktop
        max={75}
        {...object}
      />
}

export default TableCellSemaines
